import { addTranslations } from "@app/i18n";
import { useTranslation } from "react-i18next";

const RESOURCE_NAME = "sup-questionnaire";

const keys = addTranslations(RESOURCE_NAME, {
    banner_questionnaire_closed: {
        en: "This questionnaire is closed, you cannot edit it anymore",
        fr: "Ce questionnaire est fermé, vous ne pouvez plus l'éditer",
    },
    status_filter: {
        en: "Status",
        fr: "Statut",
    },
    send_questionnaire_toast_success: {
        en: "Questionnaire sent successfully",
        fr: "Questionnaire envoyé avec succès",
    },
    send_questionnaire_toast_error: {
        en: "Failed to send questionnaire",
        fr: "Erreur lors de l'envoi du questionnaire",
    },
});

export function useSupplierQuestionnaireTranslations() {
    const { t } = useTranslation(RESOURCE_NAME);
    return { t, keys };
}
